const servizi = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_SERVIZI_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_SERVIZI_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getServiziComponent: state => state.component,
        getServiziEdit: state => state.edit
    }
}

export default servizi